import { ErrorPage } from '@page/errorPage';
import * as React from 'react';
import type { RelayErrorBoundaryProps, RelayErrorBoundaryState } from './types';

class RelayErrorBoundary extends React.Component<RelayErrorBoundaryProps, RelayErrorBoundaryState> {
  constructor(props: RelayErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): RelayErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('[RelayErrorBoundary] Caught error:', error);
    console.error('[RelayErrorBoundary] Error info:', errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        const Fallback = this.props.fallback;
        return <Fallback error={this.state.error} />;
      }

      return (
        <ErrorPage
          error={{
            source: {
              errors: [
                {
                  statusCode: 500,
                  title: 'GraphQL Error',
                  message: this.state.error.message,
                },
              ],
            },
          }}
        />
      );
    }

    return this.props.children;
  }
}

export { RelayErrorBoundary };
